var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "video-container relative h-full",
      on: {
        receivedEmoji: function ($event) {
          return _vm.receiveReactions()
        },
      },
    },
    [
      _vm.url
        ? _c("div", { staticClass: "h-full" }, [
            this.videoId && _vm.type != "realtime"
              ? _c("div", {
                  staticClass: "overlay-container",
                  on: {
                    click: function ($event) {
                      return _vm.togglePlay()
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !this.nocontrols
              ? _c("div", { staticClass: "controls-container" }, [
                  _vm.type != "realtime"
                    ? _c(
                        "div",
                        {
                          class: `play-control ${
                            !_vm.playing ? "paused" : ""
                          } `,
                          on: {
                            click: function ($event) {
                              return _vm.togglePlay()
                            },
                          },
                        },
                        [
                          !_vm.playing
                            ? _c(
                                "svg",
                                {
                                  class: "icon",
                                  attrs: {
                                    viewBox: "0 0 100 100",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "svg-inline": "",
                                    role: "presentation",
                                    focusable: "false",
                                    tabindex: "-1",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M31.356 25.677l38.625 22.3c1.557.899 1.557 3.147 0 4.046l-38.625 22.3c-1.557.899-3.504-.225-3.504-2.023V27.7c0-1.798 1.946-2.922 3.504-2.023z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M69.981 47.977l-38.625-22.3a2.343 2.343 0 00-.716-.259l37.341 21.559c1.557.899 1.557 3.147 0 4.046l-38.625 22.3a2.296 2.296 0 01-1.078.301c.656.938 1.961 1.343 3.078.699l38.625-22.3c1.557-.899 1.557-3.147 0-4.046z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M31.356 25.677l38.625 22.3c1.557.899 1.557 3.147 0 4.046l-38.625 22.3c-1.557.899-3.504-.225-3.504-2.023V27.7c0-1.798 1.946-2.922 3.504-2.023z",
                                      fill: "none",
                                      stroke: "#fff",
                                      "stroke-miterlimit": "10",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.playing
                            ? _c(
                                "svg",
                                {
                                  class: "icon",
                                  attrs: {
                                    viewBox: "0 0 100 100",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "svg-inline": "",
                                    role: "presentation",
                                    focusable: "false",
                                    tabindex: "-1",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M39.806 72.858h-8.915a3.94 3.94 0 01-3.94-3.94V31.119a3.94 3.94 0 013.94-3.94h8.915a3.94 3.94 0 013.94 3.94v37.799a3.94 3.94 0 01-3.94 3.94zM68.109 72.821h-8.915a3.94 3.94 0 01-3.94-3.94V31.082a3.94 3.94 0 013.94-3.94h8.915a3.94 3.94 0 013.94 3.94v37.799a3.94 3.94 0 01-3.94 3.94z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M40.489 27.248a3.919 3.919 0 011.257 2.871v37.799a3.94 3.94 0 01-3.94 3.94h-8.915c-.234 0-.46-.03-.683-.069a3.916 3.916 0 002.683 1.069h8.915a3.94 3.94 0 003.94-3.94V31.119a3.934 3.934 0 00-3.257-3.871zM68.792 27.211a3.919 3.919 0 011.257 2.871v37.799a3.94 3.94 0 01-3.94 3.94h-8.915c-.234 0-.46-.03-.683-.069a3.916 3.916 0 002.683 1.069h8.915a3.94 3.94 0 003.94-3.94V31.082a3.933 3.933 0 00-3.257-3.871z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M39.806 72.858h-8.915a3.94 3.94 0 01-3.94-3.94V31.119a3.94 3.94 0 013.94-3.94h8.915a3.94 3.94 0 013.94 3.94v37.799a3.94 3.94 0 01-3.94 3.94zM68.109 72.821h-8.915a3.94 3.94 0 01-3.94-3.94V31.082a3.94 3.94 0 013.94-3.94h8.915a3.94 3.94 0 013.94 3.94v37.799a3.94 3.94 0 01-3.94 3.94z",
                                      fill: "none",
                                      stroke: "#000",
                                      "stroke-miterlimit": "10",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type != "realtime" && _vm.progress
                    ? _c(
                        "div",
                        { staticClass: "time-control" },
                        [
                          _c(
                            "vue-slider",
                            {
                              ref: "slider",
                              attrs: {
                                min: 0,
                                tooltip: "hover",
                                max: _vm.videoDuration,
                                tooltipFormatter: _vm.formatTime,
                                interval: 1,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.refreshTime()
                                },
                              },
                              nativeOn: {
                                mousemove: function ($event) {
                                  return _vm.mousemoveHandle.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.videoTime,
                                callback: function ($$v) {
                                  _vm.videoTime = $$v
                                },
                                expression: "videoTime",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: [
                                    "custom-tooltip",
                                    "vue-slider-dot-tooltip-inner",
                                    "vue-slider-dot-tooltip-inner-top",
                                  ],
                                  style: { left: `${_vm.left}%` },
                                },
                                [
                                  _vm._v(
                                    "\n                          " +
                                      _vm._s(_vm.formatTime(_vm.tooltipValue)) +
                                      "\n                          "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sound-control flex flex-row items-center justify-center",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "volume-control mr-4" },
                        [
                          _c("vue-slider", {
                            attrs: {
                              width: 100,
                              min: 0,
                              max: 100,
                              interval: 1,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.refreshVolume()
                              },
                            },
                            model: {
                              value: _vm.audioLevel,
                              callback: function ($$v) {
                                _vm.audioLevel = $$v
                              },
                              expression: "audioLevel",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mute-control" }, [
                        _vm.muted
                          ? _c(
                              "svg",
                              {
                                class: "icon",
                                attrs: {
                                  viewBox: "0 0 16 16",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "svg-inline": "",
                                  role: "presentation",
                                  focusable: "false",
                                  tabindex: "-1",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleMute()
                                  },
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M10 16V0L3 5H0v6h3zM14.646 5.646L13 7.293l-1.646-1.647-.708.708L12.293 8l-1.647 1.646.708.708L13 8.707l1.646 1.647.708-.708L13.707 8l1.647-1.646z",
                                  },
                                }),
                              ]
                            )
                          : _c(
                              "svg",
                              {
                                class: "icon",
                                attrs: {
                                  viewBox: "0 0 16 16",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "svg-inline": "",
                                  role: "presentation",
                                  focusable: "false",
                                  tabindex: "-1",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleMute()
                                  },
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M10 16V0L3 5H0v6h3zM11 13.91c2.837-.477 5-2.938 5-5.91s-2.163-5.433-5-5.91v1.011c2.279.465 4 2.484 4 4.899s-1.721 4.434-4 4.899v1.011z",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M11 9.722v1.094c1.163-.413 2-1.512 2-2.816s-.837-2.403-2-2.816v1.094c.595.347 1 .985 1 1.722s-.405 1.375-1 1.722z",
                                  },
                                }),
                              ]
                            ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.fullscreenable
                    ? _c(
                        "div",
                        {
                          staticClass: "fullscreen",
                          on: {
                            click: function ($event) {
                              return _vm.toggleFullscreen()
                            },
                          },
                        },
                        [
                          !_vm.fullscreen
                            ? _c(
                                "svg",
                                {
                                  class: "icon",
                                  attrs: {
                                    viewBox: "0 0 96 96",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "svg-inline": "",
                                    role: "presentation",
                                    focusable: "false",
                                    tabindex: "-1",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M30 0H6a5.997 5.997 0 00-6 6v24a6 6 0 0012 0V12h18a6 6 0 000-12zM90 0H66a6 6 0 000 12h18v18a6 6 0 0012 0V6a5.997 5.997 0 00-6-6zM30 84H12V66a6 6 0 00-12 0v24a5.997 5.997 0 006 6h24a6 6 0 000-12zM90 60a5.997 5.997 0 00-6 6v18H66a6 6 0 000 12h24a5.997 5.997 0 006-6V66a5.997 5.997 0 00-6-6z",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.fullscreen
                            ? _c(
                                "svg",
                                {
                                  class: "icon",
                                  attrs: {
                                    viewBox: "0 0 14 14",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "svg-inline": "",
                                    role: "presentation",
                                    focusable: "false",
                                    tabindex: "-1",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M0 11h3v3h2V9H0v2zm3-8H0v2h5V0H3v3zm6 11h2v-3h3V9H9v5zm2-11V0H9v5h5V3h-3z",
                                      fill: "#000",
                                      "fill-rule": "evenodd",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isLiveVideo
              ? _c(
                  "div",
                  { staticClass: "h-full" },
                  [
                    _c("VideoJS", {
                      attrs: { options: _vm.videoJsOptions },
                      on: { "on-ready": _vm.updateVjsPlayer },
                    }),
                  ],
                  1
                )
              : _c("div", { staticClass: "vue-player-container h-full" }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }